import { render, staticRenderFns } from "./CollectionPanel.vue?vue&type=template&id=1e87cf40"
import script from "./CollectionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionPanel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports